import Action from '../classes/Action';
import store, { StoreActions } from '../state/store';
import MaterialAsset from '../classes/MaterialAsset';
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";
@ActionDescription("It will set the material property of the material asset to the new value. " +
	"(Property:type) can be " +
	"('name':string)," +
	"('type':MaterialTypes), " +
	"('color':string as CSS hex value)," +
	"('map':string)," +
	"('alphaMode': AlphaModes)," +
	"('alpha':string)," +
	"('alphaCutoff':number), " +
	"('emissive': Color)\n")
@ActionParameters({materialAsset: "MaterialAsset", propertyName: "string", newValue: "any", oldValue: "any"})
@RegisterActionWithAPI("SetMaterialPropertyAction")
export default class SetMaterialPropertyAction extends Action
{
	constructor(materialAsset: MaterialAsset, propertyName: string, newValue: any, oldValue: any)
	{
		const actionName = "Set Material " + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
		super([materialAsset, propertyName, newValue], [materialAsset, propertyName, oldValue], actionName, [newValue, oldValue]);
	}

	do(materialAsset: MaterialAsset, propertyName: string, value: any)
	{
		store.dispatch(StoreActions.material.setMaterialProperty({
			id: materialAsset.guid,
			value: value,
			property: propertyName,
			shouldSubmit: false
		}));
	}
}
